import axios from "axios";
import { mediaSignature } from "@root/graphql/Common.gql";

// 文件上传通用逻辑
export default class Uploader {
  constructor(options = {}) {
    if (!(this instanceof Uploader)) {
      return new Uploader(options);
    }

    const DEFAULT_OPTIONS = {
      // 单文件最大尺寸
      maxSize: 0,
      // 是否可以上传多个文件
      multiple: false,
      // 文件名
      name: "",
      // 接受的文件类型
      accept: "*",
      // 最大上传数量
      limit: 1,
      // 上传之前的callback
      onBeforeUpload: function () {
        return true;
      },
      // 文件超出数量的回调
      onExceed: function () {},
      // 大小超限
      onOverSize: function () {},
      // 是否自动上传
      auto: true
    };

    this.options = Object.assign(
      {
        files: []
      },
      DEFAULT_OPTIONS,
      options
    );
  }

  // 监听文件变化
  onInput(e) {
    let { multiple, limit } = this.options;

    let files = e.target.files;
    let filesList = Array.prototype.slice.call(files, 0);

    // limit validate
    if (files.length && multiple && files.length > limit) {
      return this.onExceed(files);
    }

    // size validate
    let sizeVaildResult = this.sizeVaild(filesList);
    if (sizeVaildResult) {
      return this.onOverSize(sizeVaildResult);
    }

    // accept validate
    // 不需要吧

    // cache
    this.files = files;
    this.filesList = filesList;

    // start
    this.auto && this.start();
  }

  // 尺寸验证
  async sizeVaild(fileList) {
    const { maxSize } = this.options;
    const result = [];

    fileList.forEach(file => {
      const { size } = file;
      if (size / 1024 > maxSize) {
        result.push(file);
      }
    });

    return result.length ? result : false;
  }

  // start
  async start() {
    // 上传之前的callback
    const beforeRes = this.onBeforeUpload(this.files);
    if (!beforeRes) return;

    // 获取token
    await this.updateToken();
  }
}

// 阿里云上传逻辑
export class OssUploaderForGtech {
  constructor(options) {
    const DEFAULT_OPTIONS = {
      // 获取token的入参
      getTokenOptions: {
        tenantCode: "23r"
      },

      gqlClient: null,

      // onfailure
      onfailure: function () {},

      // onsuccess
      onsuccess: function () {}
    };

    Object.assign(this, DEFAULT_OPTIONS, options);

    // oss信息
    this.cloudOpts = null;

    // formdata
    this.formData = null;

    // status
    this.onUploading = false;

    // filepath
    this.filepath = "";
  }

  // 获取上传的token
  async updateToken() {
    return new Promise(async (resolve, reject) => {
      if (!this.gqlClient) {
        this.onfailure("gqlClient is required");
        reject("gqlClient is required");
      }

      try {
        let {
          data: { mediaSignature: resData }
        } = await this.gqlClient.query({
          query: mediaSignature,
          variables: this.getTokenOptions
        });

        this.cloudOpts = resData;

        resolve();
      } catch (err) {
        this.onfailure(err);
        reject(err);
      }
    });
  }

  createFormData(file) {
    const type = file.type.split("/");
    const filename = `${createUUID(32, 16)}.${type[type.length - 1]}`;
    const { dir, accessid, policy, signature, domain } = this.cloudOpts;

    let formData = new FormData();
    formData.append("Filename", filename);
    formData.append("key", dir + filename); //存储在oss的文件路径
    formData.append("OSSAccessKeyId", accessid); //accessKeyId
    formData.append("policy", policy); //policy
    formData.append("Signature", signature); //签名
    formData.append("file", file);
    formData.append("success_action_status", "200");

    this.formData = formData;
    this.filepath = `${domain}/${dir}${filename}`;
  }

  upload() {
    return new Promise(async (resolve, reject) => {
      if (!this.cloudOpts) {
        reject("Get token first");
      }

      if (this.onUploading) {
        reject("Waiting the last process end");
      }

      try {
        this.onUploading = true;

        await axios.post(this.cloudOpts.host, this.formData);

        resolve(this.filepath);
      } catch (err) {
        reject(err);
      } finally {
        this.onUploading = false;
      }
    });
  }

  // start
  async start(file) {
    // get token
    await this.updateToken();

    // create fordata
    this.createFormData(file);

    // uploader
    await this.upload();

    this.onsuccess(this.filepath);
  }
}

// 上传工具
function fetch({
  withCredentials = true,
  timeout = 10000,
  action = null,
  methods = "post",
  headers = null,
  body = ""
} = {}) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();

    // check required params
    if (!action) {
      reject("param <action> is required");
      return;
    }

    // setting
    xhr.withCredentials = withCredentials;
    xhr.timeout = timeout;

    // set headers
    if (headers) {
      for (let header in headers) {
        xhr.setRequestHeader(header, headers[header]);
      }
    }

    xhr.open(methods, action);

    xhr.onload = function () {
      if (xhr.status != 200) {
        reject("HTTP Error: " + xhr.status);
        return;
      }

      var data = JSON.parse(xhr.responseText);

      resolve(data);
    };

    xhr.send(body);
  });
}

// createUUID
function createUUID(len, radix) {
  let chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  let uuid = [],
    i;
  radix = radix || chars.length;

  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r;

    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}
